import { render, staticRenderFns } from "./ImportRes.vue?vue&type=template&id=09135c2a&scoped=true&"
import script from "./ImportRes.vue?vue&type=script&lang=js&"
export * from "./ImportRes.vue?vue&type=script&lang=js&"
import style0 from "./ImportRes.vue?vue&type=style&index=0&id=09135c2a&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09135c2a",
  null
  
)

export default component.exports